import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pageTitle" }
const _hoisted_3 = { class: "midTitle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "midTitle mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_dati_base_user = _resolveComponent("dati-base-user")!
  const _component_dati_lead = _resolveComponent("dati-lead")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: "Visualizza:",
            text: "Visualizza:"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.user.personalData.name) + " " + _toDisplayString(_ctx.user.personalData.surname), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_localized_text, {
            localizedKey: "Dati base",
            text: "Dati base"
          })
        ]),
        _hoisted_4,
        _createVNode(_component_dati_base_user, {
          user: _ctx.user,
          roles: _ctx.rolesList,
          readonly: true,
          onInit: _ctx.init,
          canEditStatoCommerciale: true
        }, null, 8, ["user", "roles", "onInit"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Dati lead",
            text: "Dati lead"
          })
        ]),
        _hoisted_6,
        _createVNode(_component_dati_lead, {
          user: _ctx.user,
          readonly: true
        }, null, 8, ["user"])
      ]))
    : _createCommentVNode("", true)
}